import { translate } from "app/filters/i18nFilter";
import type { ColummListColumn } from "app/pages/sales-intelligence/common-components/search-results-table";
import type { TableColumnTypeDto } from "app/pages/sales-intelligence/modules/apps-search/types/rows";
import type { LeadCellRecord, MainDomainDto } from "app/pages/sales-intelligence/modules/leads-search/types/rows";

type Column<R> = Pick<ColummListColumn<R>, "dataIndex"> & Partial<Omit<ColummListColumn<R>, "dataIndex">>;
export const createRegularColumnFactory =
    <RecordType>(column: Column<RecordType>) =>
    (dto: TableColumnTypeDto): Readonly<ColummListColumn<RecordType>> =>
        ({
            title: translate(`si.find_apps.table.column.title.${dto.name}`),
            tooltipTitle: translate(`si.find_apps.table.column.tooltip-title.${dto.name}`),
            fixed: dto.isStatic ? "left" : false,
            width: 190,
            sorter: true,
            ...column,
        }) as Readonly<ColummListColumn<RecordType>>;

export const createDynamicColumnFactory =
    <RecordType>(column: Partial<ColummListColumn<RecordType>>) =>
    (dto: TableColumnTypeDto): Readonly<ColummListColumn<RecordType>> =>
        ({
            dataIndex: dto.id as keyof RecordType,
            title: dto.name,
            tooltipTitle: translate(`si.find_apps.table.column.tooltip-title.${dto.type}`),
            fixed: dto.isStatic ? "left" : false,
            sorter: true,
            ...column,
        }) as Readonly<ColummListColumn<RecordType>>;

export const buildLeadCellRecord = (mainDomain: MainDomainDto): LeadCellRecord => ({
    company: mainDomain.company_name,
    favicon: mainDomain.favicon,
    company_domains: [
        {
            domain: mainDomain.domain,
            isMainDomain: true,
            headQuarter: 0,
        },
    ],
    is_new: false,
    index: 0,
});
